<template>
  <div>
    <equipment-list-table />
  </div>
</template>

<script>
import EquipmentListTable from "../../../InventoryModule/EquipmentManagement/partials/EquipmentListTable.vue";

export default {
  name: "service-center-view-equipments",

  components: {
    EquipmentListTable,
  },

  props: ["serviceCenter"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    serviceCenter(serviceCenter) {},
  },
};
</script>
